function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.64578 9.2772L9.10615 2.94445C9.93734 2.12968 11.2855 2.12968 12.1167 2.94445L12.9796 3.7903C13.8108 4.60508 13.8108 5.9266 12.9796 6.74138L6.49374 13.0991C6.12287 13.4626 5.62005 13.6666 5.09521 13.6666H2.43903C2.19228 13.6666 1.99399 13.4674 2.00014 13.2256L2.06695 10.5983C2.08024 10.1018 2.28751 9.62839 2.64578 9.2772ZM12.3587 4.39891L11.4958 3.55306C11.0075 3.07442 10.2153 3.07442 9.72702 3.55306L9.22549 4.04469L11.8575 6.62412L12.3587 6.13277C12.847 5.65412 12.847 4.87756 12.3587 4.39891ZM3.26665 9.88581L8.60461 4.6533L11.2366 7.23273L5.87286 12.4905L5.80152 12.5545C5.60447 12.7164 5.35481 12.8059 5.09521 12.8059L2.88897 12.8056L2.94472 10.6203C2.95209 10.3446 3.06751 10.081 3.26665 9.88581ZM14 13.2364C14 12.9987 13.8034 12.806 13.561 12.806H8.98066L8.92109 12.8099C8.7068 12.8384 8.54164 13.0185 8.54164 13.2364C8.54164 13.474 8.7382 13.6667 8.98066 13.6667H13.561L13.6205 13.6628C13.8348 13.6343 14 13.4542 14 13.2364Z",
  fill: "white"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a8ff68d1.svg";
export { ForwardRef as ReactComponent };